import { render } from "./SlidePlayer.vue?vue&type=template&id=38af4710"
import script from "./SlidePlayer.vue?vue&type=script&lang=js"
export * from "./SlidePlayer.vue?vue&type=script&lang=js"

import "./SlidePlayer.vue?vue&type=style&index=0&id=38af4710&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__